/*
 * Home "Featured This Week" — 6 real, in-stock items, tag-driven.
 *
 * Loaded after sat-app.js (defer, in order) and before the app's first render, so
 * it wraps SATComponent.prototype.renderVals before SAT.mount() ever calls it.
 * Which 6 products show is entirely the merchant's call: tag a product "featured"
 * on its Shopify product page and it takes a slot; edit that product's title,
 * price, photo, description, or era on the product page and the card updates on
 * its own — no theme or code edit either way.
 *
 * The filtering happens here in JS against window.SAT_DATA.products (which now
 * carries each product's tags — see snippets/sat-bootstrap.liquid) rather than in
 * Liquid: Shopify's `where` filter does an exact-match on a property, not an
 * array-contains check, so `sat_products | where: 'tags', 'featured'` never
 * actually matched a tag and silently always fell back to the first 6 products.
 * `tags.indexOf('featured') !== -1` below is the real check.
 *
 * Ordering within whichever pool ends up on screen — the tagged set, or the
 * full catalog when nothing's tagged — used to just be catalog order (Shopify's
 * own default sort), which put whatever the merchant happened to add last (or
 * first) in the storefront's single most visible spot for no reason tied to
 * the business. Sorted now by assets/sat-sales-rank.js's shared
 * bestSellersFirst() — real order-count-and-revenue data from this shop's own
 * analytics, in-stock items ahead of sold-out ones — the same ranking The
 * Southern Air Import's home-page teaser sorts by (assets/sat-import-pager-
 * patch.js), so the two most visible product spots on the site never
 * disagree about what's actually selling. It's a ranking signal, not a
 * filter: a product with no sales history yet still shows (falls to the back
 * of its pool, not out of it), and the merchant's own "featured" tag still
 * overrides all of this by choosing the pool in the first place.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;
    var pool = (self._products || []).filter(function (p) {
      return p.tags && p.tags.indexOf('featured') !== -1;
    });
    if (!pool.length) pool = self._products || [];
    var ranked = window.SATSalesRank ? window.SATSalesRank.bestSellersFirst(pool) : pool;
    var items = ranked.slice(0, 6);

    for (var i = 0; i < 6; i++) {
      (function (i) {
        var p = items[i];
        var key = function (k) { return 'hf' + i + k; };
        if (!p) {
          out[key('Show')] = 'none';
          out[key('Id')] = '';
          out[key('Photo')] = '';
          out[key('SlotId')] = 'hf-empty-' + i;
          out[key('Name')] = '';
          out[key('Blurb')] = '';
          out[key('PriceLabel')] = '';
          out[key('EraLabel')] = '';
          out[key('StockLabel')] = '';
          out[key('Open')] = function () {};
          return;
        }
        out[key('Show')] = 'block';
        out[key('Id')] = p.id;
        out[key('Photo')] = p.photo || '';
        out[key('SlotId')] = 'hf-' + p.id;
        out[key('Name')] = p.name;
        out[key('Blurb')] = p.blurb;
        out[key('PriceLabel')] = '$' + p.price;
        out[key('EraLabel')] = p.era ? (p.era + ' record') : 'In Stock';
        out[key('StockLabel')] = p.stock <= 0 ? 'Sold Out' : (p.stock > 5 ? 'In Stock' : 'Only ' + p.stock + ' On File');
        out[key('Open')] = function () {
          self.setState({ detailId: p.id });
          self.noteSeen(p.id, p.name);
          self.siteTone('b', 0.045);
        };
      })(i);
    }
    return out;
  };
})();
